module.exports = __webpack_public_path__ + "static/media/icon-annual-physical.62b78663.svg";